<!--
 * @Author: your name
 * @Date: 2021-06-25 18:04:51
 * @LastEditTime: 2021-07-26 17:30:47
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \xingmahui_front\src\views\contents\cageChild\component\tab.vue
-->
<template>
  <van-tabs @click="getInfo" v-model="active">
    <van-tab
      v-for="(item, index) in childTagList"
      :key="index"
      :name="item.id"
      :title="item.name | exIntroFilter"
    >
    </van-tab>
  </van-tabs>
</template>
<script>
export default {
  data() {
    return {
      childTagList: [],
      active: "",
    };
  },
  props: {
    tagList: {
      type: Array,
      default: [],
    },
  },
  watch: {
    tagList: {
      handler(newVal, oldVal) {
        {
          this.active = 0
          this.childTagList = newVal;
          if(newVal.length >= 6){
            this.$nextTick(()=>{
                // $('.van-tab').css({'padding':'0 10px'})
            })
            
            
          }
        }
      },
      deep: true,
    },
  },

  methods: {
    getInfo(name,title) {
      this.$emit("sendId", name,title);
    },
  },
  filters: {
    exIntroFilter: function(text) {
      if (text && text.length > 6) {
        return text.substring(0, 6) + "..";
      } else {
        return text;
      }
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .van-tabs__line {
  display: none;
}
/deep/ .van-tab .van-tab__text {
  font-size: 12px;
  min-width: 52px;
  padding: 0 8px;
  display: block;
  text-align: center;
  color: #333333;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  background: #f5f5f5;
  border-radius: 20px;
  text-align: center;
  line-height: 24px;
  height: 24px;
}
/deep/ .van-tab{
  padding: 0 8px;
}

/deep/ .van-tab--active .van-tab__text {
  background: #e5c694;

  color: #fff;
}
/deep/ .van-tabs__wrap{
  margin-top: 10px;
}
</style>
